// extracted by mini-css-extract-plugin
export default {"route":"classes_route__qxbDD","content":"classes_content__3ZY7R","link":"classes_link__L6KFb","active-route":"classes_active-route__lUrTB"};